export const isEven = (input:number) =>  input % 2 === 0 

export const getEvenClass = (input:number) =>  isEven(input) ? 'even-row' : 'odd-row'